import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'talk-to-your-data-new-chat-button',
  templateUrl: './new-chat-button.component.html',
  styleUrls: ['./new-chat-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewChatButtonComponent {
  @Output() readonly newChatClicked = new EventEmitter<void>();

  onClick(): void {
    this.newChatClicked.emit();
  }
}
